import { render, staticRenderFns } from "./index.vue?vue&type=template&id=71ef7437&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=71ef7437&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ef7437",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71ef7437')) {
      api.createRecord('71ef7437', component.options)
    } else {
      api.reload('71ef7437', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=71ef7437&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml", function () {
      api.rerender('71ef7437', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Events/EventView/index.vue"
export default component.exports